import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

//Import Styles
import "./DashboardExclutions.scss";
import "../../Loader/DashboardLoader.scss";

import DialogHoneyLoad from "../../../Components/DialogHoneyLoad/DialogHoneyLoad";
import DialogLoaderHoneyLoad from "../../../Components/DialogLoaderHoneyLoad/DialogLoaderHoneyLoad";
import fetchAPI from "../../../../../components/utils/fetchAPI";
import runtimeEnv from "@mars/heroku-js-runtime-env";
import Dropdown from "react-bootstrap/Dropdown";
import Dialog from "@material-ui/core/Dialog";
import StyledDropzone from "../../../../../components/utils/dropzone";
import { LinearProgress } from "@mui/material";

import { MsalContext } from "@azure/msal-react";
import SimpleCard from "./SimpleCard/SimpleCard";
import TreeCardOffices from "./SimpleCard/TreeCardOffices";
import TreeCardSegments from "./SimpleCard/TreeCardSegments";
import { readFile } from "../../../../../components/utils/readFile";
import { textToB64 } from "../../../../../components/utils/textToB64";
import { iterator } from "../../../../../components/utils/helpers";
import { chunksAccounts } from "../../../../../components/utils/chunksAccounts";

const env = runtimeEnv();
export default class DashboardExclutions extends Component {
  static contextType = MsalContext;

  state = {
    titleSales: "GERENCIA DE VENTAS",
    titleClientsType: "TIPIFICACIÓN DE CLIENTES",
    titleGeoZone: "ZONA GEOGRÁFICA",
    titleClients: "CLIENTES",

    buttonUpdateLabel:
      this.props.countriesCode !== "mdcolombia"
        ? "Crear registro"
        : "Guardar registro",

    templateDialog: null,
    checkedValuesOfices: [],
    checkedValuesSegments: [],

    rulesToSave: {},
    refsCardsMX: [
      // "drv",
      "zone",
      "org",
      "sales_orgs",
      "segment_concesionarios",
      "clients_exception",
      "clients",
    ],
    refsCards: [
      "sales_orgs",
      "offices",
      "plants",
      "channels",
      "subchannels",
      "business_types",
      "municipalities",
      "regions",
      "clients_exception",
      "clients",
    ],

    updateCard: false,
    changeRules: [],
    labelDropdown: "Nueva Carga",
    dropdownOptions: ["Exclusiones", "Excepciones"],
    selectedType: "",
    dialogOpen: false,
    dialogSectionFile: true,
    dialogLoadingFile: false,
    selectedCountryCode: "",
    rowsSKU: [],
    rowsExclutions: [],
    rowsPromotions: [],
    responseCompletedSKU: false,
    responseCompletedClient: false,
    responseAnswerCountry: false,
    fileProgress: 0,
    responseFileProgress: "",
    userId: "",

    /** Validate Clients */
    validating: false,
    aculatorUploadClients: 0,
    totalUploadClients: 0,
    responseFileErrorMessage:''
  };

  constructor(props) {
    super(props);
  }

  openDialog = ({
    message,
    showIcon,
    iconType,
    buttonCancel,
    buttonAccept,
    onClickCancel,
    onClickAccept,
  }) => {
    this.setState({
      templateDialog: null,
    });
    const templateDialog = (
      <DialogHoneyLoad
        opened={true}
        showIcon={showIcon}
        iconType={iconType}
        message={message}
        buttonCancel={buttonCancel}
        buttonAccept={buttonAccept}
        onClickCancel={onClickCancel}
        onClickAccept={onClickAccept}
      />
    );
    this.setState({
      templateDialog: templateDialog,
    });
  };

  handleDateChange = (e) => (date) => {
    if (e === "start") {
      return this.props.setSelectedDateStart(date);
    } else {
      return this.props.setSelectedDateEnd(date);
    }
  };

  handleButtonRemoveValidity = (evt) => {
    this.props.setSelectedDateStart(null);
    this.props.setSelectedDateEnd(null);
  };

  getRulesCards = async (countriesCode) => {
    if (countriesCode === "mdmexico") {
      await Promise.all(
        this.state.refsCardsMX.map((cardRef) => this.refs[cardRef].emiteRules())
      );
    } else {
      await Promise.all(
        this.state.refsCards.map((cardRef) => this.refs[cardRef].emiteRules())
      );
    }
  };

  petitionClients = async (data, options) => {
    const { codeCountry, service, isDelete = false, counter = 0 } = options;
    const ite = data.next();
    if (ite.done) return;
    const accounts = ite.value;
    await new Promise(async (resolve, reject) => {
      await fetchAPI({
        service: isDelete ? `${service}?isDelete=true` : service,
        protocol: "POST",
        params: { accounts },
        codeCountry,
        callbackThen: (response) => {
          resolve(response.data);
        },
        callbackError: (err) => {
          // TODO clientes infinitos: limite de 100 peticiones
          if (counter <= 20)
            return this.petitionClients(accounts, {
              codeCountry,
              service,
              isDelete,
              counter: counter++,
            });
          else reject([]);
        },
      });
    });

    return this.petitionClients(data, options);
  };

  saveRules = async (serviceURL, params, clientsToSave, codeCountry) => {
    let toSave = clientsToSave.clients.toSave.map((x) => ({
      ...x,
      type: "exclusion",
    }));
    toSave = [
      ...toSave,
      ...clientsToSave.clients_exception.toSave.map((x) => ({
        ...x,
        type: "exception",
      })),
    ];
    let toDelete = clientsToSave.clients.toDelete.map((x) => ({
      ...x,
      type: "delete",
    }));
    toDelete = [
      ...toDelete,
      ...clientsToSave.clients_exception.toDelete.map((x) => ({
        ...x,
        type: "delete",
      })),
    ];
    let RESULT = null;
    try {
      try {
        RESULT = await new Promise((resolve, reject) => {
          fetchAPI({
            service: serviceURL,
            protocol: this.props.index > 0 ? "PUT" : "POST",
            params: params,
            codeCountry,
            callbackThen: (response) => {
              resolve(response.exclusion);
            },
            callbackError: (err) => {
              reject(err);
            },
          });
        });
      } catch (e) {
        throw Error("Error al guardar la regla");
      }
      
      // Permite mostrar mensajes personalizados desde el back-end
      if (Object.hasOwnProperty.call(RESULT, 'ECODE')) {
        throw Error(RESULT.message);
      }

      try {
        let serviceURLClient = env.REACT_APP_SERVICES_INFINITI_CLIENTS_SEND;
        serviceURLClient = serviceURLClient.replace(
          "<countryCode>",
          this.props.selectedCountry
        );
        serviceURLClient = serviceURLClient.replace(
          "<batchId>",
          this.props.index > 0 ? this.props.idLote : RESULT.id
        );
        const resultSave = await this.petitionClients(
          iterator(chunksAccounts(toSave, env.REACT_APP_DIVIDER_CLIENTS)),
          {
            codeCountry,
            service: serviceURLClient,
            isDelete: false,
          }
        );
        const resultDelete = await this.petitionClients(
          iterator(chunksAccounts(toDelete, env.REACT_APP_DIVIDER_CLIENTS)),
          {
            codeCountry,
            service: serviceURLClient,
            isDelete: true,
          }
        );
      } catch (e) {
        throw Error("Error al guardar varios los clientes");
      }
      // TODO clientes infinitos: reestablecer lientsToSave y reglas principales para backup;

      this.props.handleAddBatch(RESULT);
      this.openDialog({
        message: "Registro creado con éxito",
        iconType: "success",
        showIcon: true,
        onClickAccept: () => {
          this.setState({
            templateDialog: null,
          });
          if (this.props.index > 0) {
          } else {
            this.props.emptyExclutions();
          }
        },
      });
    } catch (e) {
      console.log(e);
      this.openDialog({
        message: e.message ? e.message : "Error al guardar la regla",
        showIcon: true,
        onClickAccept: () => {
          this.setState({
            templateDialog: null,
          });
          if (this.props.index > 0) {
          } else {
            this.props.emptyExclutions();
          }
        },
      });
    }
  };

  // TODO: Fix get rules to save
  handleButtonUploadRulesSKU = async () => {
    this.openDialog({
      message: "Recopilando reglas",
      iconType: "updating",
      showIcon: true,
      buttonAccept: false,
    });
    await this.getRulesCards(this.props.countriesCode);

    if (this.props.countriesCode === "mdcolombia" || this.props.countriesCode === "mdmexico") {
      let serviceURL = env.REACT_APP_SERVICES_POST_BATCH_EXCLUTIONS_RULES_SKU;
      if (this.props.index > 0) {
        serviceURL = env.REACT_APP_SERVICES_PUT_BATCH_EXCLUTIONS_RULES_SKU;
      }
      serviceURL = serviceURL.replace(
        "<countryCode>",
        this.props.selectedCountry
      );
      if (this.props.index > 0) serviceURL = serviceURL + this.props.idLote;

      if (
        Object.keys(this.state.rulesToSave).filter(
          (key) => this.state.rulesToSave[key].length !== 0
        ).length <= 0 &&
        Object.keys(this.state.clientsToSave.clients).filter(
          (key) => this.state.clientsToSave.clients[key].length !== 0
        ).length <= 0 &&
        Object.keys(this.state.clientsToSave.clients_exception).filter(
          (key) => this.state.clientsToSave.clients_exception[key].length !== 0
        ).length <= 0
      ) {
        this.openDialog({
          message: "Debe seleccionar al menos una regla de exclusión",
          showIcon: true,
          onClickAccept: () => {
            this.setState({
              templateDialog: null,
            });
          },
        });
        return false;
      } else {
        this.openDialog({
          message: "Guardando registro",
          iconType: "updating",
          showIcon: true,
          buttonAccept: false,
        });
      }

      const params = {
        mat_no: this.props?.selectedProduct?.sku,
        rules: this.state.rulesToSave,
        clients_exclusions: [],
      };

      let expDate = null;
      let startDate = null;

      if (
        typeof this.props.selectedDateStart === "object" &&
        this.props.selectedDateStart !== null
      ) {
        startDate =
          this.props.selectedDateStart.getMonth() +
          1 +
          "/" +
          this.props.selectedDateStart.getDate() +
          "/" +
          this.props.selectedDateStart.getFullYear();
        params.startDate = startDate;
        console.log("dechaselected", this.props.selectedDateStart);
      } else {
        if (
          typeof this.props.selectedDateStart === "string" &&
          this.props.selectedDateStart !== null
        ) {
          startDate = this.props.selectedDateStart;
          params.startDate = startDate;
        }
      }

      if (
        typeof this.props.selectedDateEnd === "object" &&
        this.props.selectedDateEnd !== null
      ) {
        expDate =
          this.props.selectedDateEnd.getMonth() +
          1 +
          "/" +
          this.props.selectedDateEnd.getDate() +
          "/" +
          this.props.selectedDateEnd.getFullYear();
        params.expDate = expDate;
      } else {
        if (
          typeof this.props.selectedDateEnd === "string" &&
          this.props.selectedDateEnd !== null
        ) {
          expDate = this.props.selectedDateEnd;
          params.expDate = expDate;
        }
      }

      await this.saveRules(
        serviceURL,
        params,
        this.state.clientsToSave,
        this.props.selectedCountry
      );
    } else {
      let serviceURL = env.REACT_APP_SERVICES_POST_BATCH_EXCLUTIONS_RULES_SKU;
      if (this.props.index === 0) {
        serviceURL = env.REACT_APP_SERVICES_POST_BATCH_EXCLUTIONS_RULES_SKU;
      } else {
        serviceURL = env.REACT_APP_SERVICES_PUT_BATCH_EXCLUTIONS_RULES_SKU;
      }
      serviceURL = serviceURL.replace(
        "<countryCode>",
        this.props.selectedCountry
      );
      if (this.props.index > 0) serviceURL = serviceURL + this.props.idLote;

      if (
        Object.keys(this.state.rulesToSave).filter(
          (key) => this.state.rulesToSave[key].length !== 0
        ).length <= 0
      ) {
        this.openDialog({
          message: "Debe seleccionar al menos una regla de exclusión",
          showIcon: true,
          onClickAccept: () => {
            this.setState({
              templateDialog: null,
            });
          },
        });
        return false;
      } else {
        this.openDialog({
          message: "Guardando registro",
          iconType: "updating",
          showIcon: true,
          buttonAccept: false,
        });
      }

      const paramsMex = {
        mat_no: this.props.selectedProduct.sku,
        rules: this.state.rulesToSave,
        clients_exclusions: [],
      };

      let expDate = null;
      let startDate = null;

      if (
        typeof this.props.selectedDateStart === "object" &&
        this.props.selectedDateStart !== null
      ) {
        startDate =
          this.props.selectedDateStart.getMonth() +
          1 +
          "/" +
          this.props.selectedDateStart.getDate() +
          "/" +
          this.props.selectedDateStart.getFullYear();
        paramsMex.startDate = startDate;
        console.log("dechaselected", this.props.selectedDateStart);
      } else {
        if (
          typeof this.props.selectedDateStart === "string" &&
          this.props.selectedDateStart !== null
        ) {
          startDate = this.props.selectedDateStart;
          paramsMex.startDate = startDate;
        }
      }

      if (
        typeof this.props.selectedDateEnd === "object" &&
        this.props.selectedDateEnd !== null
      ) {
        expDate =
          this.props.selectedDateEnd.getMonth() +
          1 +
          "/" +
          this.props.selectedDateEnd.getDate() +
          "/" +
          this.props.selectedDateEnd.getFullYear();
        paramsMex.expDate = expDate;
      } else {
        if (
          typeof this.props.selectedDateEnd === "string" &&
          this.props.selectedDateEnd !== null
        ) {
          expDate = this.props.selectedDateEnd;
          paramsMex.expDate = expDate;
        }
      }
      await this.saveRules(
          serviceURL,
          paramsMex,
          this.state.clientsToSave,
          this.props.selectedCountry
      );
    }
  };

  toggleDialogOpen = async () => {
    return new Promise((res) => {
      this.setState(
        {
          dialogOpen: !this.state.dialogOpen,
          dialogSectionFile: true,
        },
        res
      );
    });
  };

  handleDialogCombo = async (eventKey, event) => {
    const selectedFileType = event.target.innerHTML;
    this.setState({
      selectedType: selectedFileType,
    });
    await this.toggleDialogOpen();
  };

  handleDialogClose = async () => {
    await this.toggleDialogOpen();
    this.setState({
      loaderFiles: [],
    });
  };

  getBase64 = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  loadFileBase64 = async (base64, callbackSuccess, callbackError) => {
    const selectedCountryCode = this.props.countriesCode;
    const fileBase64 = base64.split("base64,");
    const dataSend = {
      file: fileBase64[1],
      sku: this.props?.selectedProduct?.sku,
      type: this.state.selectedType === 'Exclusiones' ? 'exclusion' : 'exception'
    };
    let service = env.REACT_APP_SERVICES_LOADER_UPLOAD_FILE_VALIDATION;

    await fetchAPI({
      params: dataSend,
      service: service.replace("<countryCode>", selectedCountryCode),
      codeCountry: selectedCountryCode,
      callbackThen: callbackSuccess,
      callbackError: callbackError,
    });
  };

  validateRecursiveClients = async (data, totalAcc, limit) => {
    const ite = data.next();
    if (ite.done) return true;
    const { value, index } = ite;
    try {
      await new Promise((res, rej) =>
        this.loadFileBase64(
          textToB64(value),
          async (response) => {
            await new Promise((resC, rejC) => {
              if (response?.code === 400) {
                this.setState(
                  {
                    dialogOpen: response?.code === 400,
                    fileProgress: 400,
                    validating: false,
                    dialogSectionFile: false,
                    dialogLoadingFile: true,
                    responseFileProgress: response?.message
                      ? response.message
                      : "Validacion clientes",
                    responseFileErrorMessage: response.message
                  },
                  rejC
                );
              } else
                this.setState(
                  {
                    fileProgress: ((index + 1) / totalAcc) * 100,
                    aculatorUploadClients:
                      parseInt(this.state.aculatorUploadClients, 10) +
                      parseInt(limit, 10),
                    responseFileProgress: response?.message
                      ? response.message
                      : "Validacion clientes",
                    responseCompletedClient: response.message
                      ? response.message.includes("ClientId")
                      : "",
                  },
                  resC
                );
            });
            if (response?.accounts && response.accounts.length > 0) {
              switch (this.state.selectedType) {
                case "Exclusiones":
                  await this.props.setClientsExclusions(response.accounts);
                  break;
                case "Excepciones":
                  await this.props.setClientsException(response.accounts);
                  break;
                default:
                // callbackError("Error not service aviable.");
              }
            }
            res(true);
          },
          (e) => {
            console.log(e);
            rej(e);
          }
        )
      );
    } catch (e) {
      throw Error(e);
    }
    return this.validateRecursiveClients(data, totalAcc, limit);
  };

  handleGetFile = async (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      await this.handleLoadingFileCloseButton();
      await new Promise((res) => {
        this.setState(
          {
            validating: true,
          },
          res
        );
      });

      const limit = env.REACT_APP_LIMIT_VALIDATE_CLIENTS;

      const { result, total } = await readFile(acceptedFiles[0], limit);
      await new Promise((res) => {
        this.setState(
          {
            totalUploadClients: total,
          },
          res
        );
      });
      let fileProgress = true;
      try {
        await this.validateRecursiveClients(iterator(result), total, limit);
      } catch (e) {
        fileProgress = false;
      } finally {
        this.setState({
          fileProgress: fileProgress ? 100 : 400,
          validating: false,
          totalUploadClients: 0,
          aculatorUploadClients: 0,
          responseFileProgress: "Validacion completada",
          responseCompletedClient: "Validacion completada",
        });
      }
    }
  };

  handleLoadingFileCloseButton = () => {
    return new Promise(async (res) => {
      await this.toggleDialogOpen();
      this.setState(
        {
          dialogSectionFile: true,
          dialogLoadingFile: false,
          esponseFileProgress: "",
          fileProgress: 0,
        },
        res
      );
    });
  };

  compareCleintes = (clients) => {};

  storageRules = (properties, data) => {
    const rulesToSave = this.state.rulesToSave;
    const clientsRules = Object.assign({}, this.state.clientsToSave);

    if (
        ((this.props.selectedCountry === "mdcolombia"||
      this.props.selectedCountry === "mdmexico"))&&
      ["clients", "clients_exception"].includes(properties[0])
    ) {
      let currentClients = [];
      if ("clients" === properties[0]) {
        currentClients = Object.assign(
          [],
          this.props.infinityClients.clientsExclusion
        );
      }
      if ("clients_exception" === properties[0]) {
        currentClients = Object.assign(
          [],
          this.props.infinityClients.clientsException
        );
      }

      let prev = currentClients.map((x) => x.cust_no);

      let current = data[properties[0]];

      const toDelete = currentClients.filter(
        (x) => !current.includes(x.cust_no)
      );
      const toSave = current
        .filter((x) => !prev.includes(x))
        .map((x) => ({
          cust_no: x,
          exp_date: null,
          start_date: null,
        }));
      clientsRules[properties[0]] = {
        toDelete,
        toSave,
      };
    } else {
      properties.map((property) => {
        rulesToSave[property] = data[property] || [];
      });
    }
    this.state.clientsToSave = {
      ...this.state.clientsToSave,
      ...clientsRules,
    };
    this.state.rulesToSave = rulesToSave;
  };
  getRuleStatusMessage = (status_code) => {
    switch(status_code){
      case 'created':
        return 'Pendiente de envío a Bees'
      case 'bees_upload_success':
        return 'Enviado a Bees exitosamente'
      case 'expiration_bees_upload_success':
        return 'Expiración enviada a Bees exitosamente'
      case 'bees_upload_with_errors':
        return 'Enviado a Bees con errores'
      case 'expiration_bees_upload_with_errors':
        return 'Expiración enviada a Bees con errores'
    }
  }

  render() {
    const viewFileSelection = this.state.dialogSectionFile ? "" : " hide";
    const viewLoadingSelection = this.state.dialogLoadingFile ? "" : " hide";

    const labelButton =
      this.state.fileProgress === -1 || this.state.fileProgress === 400
        ? "Cerrar"
        : "Guardar";

    const classButtonSuccess =
      `loader__button-loader black` +
      (this.state.fileProgress === 100 ||
      this.state.fileProgress === -1 ||
      this.state.fileProgress === 400
        ? ""
        : " hide");

    const classIconLoading =
      `loader__loading--icon` +
      (this.state.fileProgress === 100
        ? " success"
        : this.state.fileProgress === 400 || this.state.fileProgress === -1
        ? " error"
        : " success");

    const labelFileLoading =
      this.state.fileProgress === 100 || this.state.fileProgress === 201
        ? "Archivo cargado con éxito"
        : this.state.fileProgress === -1
        ? "Error al cargar el archivo"
        : this.state.fileProgress === 400
        ? this.state.responseCompletedSKU
          ? this.props.countriesCode === "mdmexico"
            ? "El número de caracteres para la asignación de un SKU es de 7"
            : "El número de caracteres para la asignación de un SKU es de 5"
          : this.state.responseCompletedClient
          ? this.props.countriesCode === "mdmexico"
            ? "El número de caracteres para el ID SAP del cliente debe ser de 9"
            : "El número de caracteres para el ID SAP del cliente debe ser de 8"
          : this.props.countriesCode === "mdmexico"
          ? `El ID del cliente no pertenece a México.`
          : `El ID del cliente no pertenece a Colombia.`
        : "Cargando archivo";

    const defaultCards =
      this.props.countriesCode === "mdmexico" ? (
        <>
          <Grid item xs={12}  container
                direction="row"
                justifyContent="flex-end"
                alignItems="center">
            {
              this.props.selectedGroupData?
                  <div className="exclutions__category">
                    {this.getRuleStatusMessage(this.props.selectedGroupData.status)}
                  </div>
                  :<></>
            }
          </Grid>
          <Grid item xs={4} md={4}>
            <SimpleCard
              card={this.props.cards.cardZoneMX}
              ref={this.state.refsCardsMX[0]}
              property="zone"
              service={this.props.cards.cardZoneMX.service}
              setRules={this.storageRules}
            />

            {/*
            <TreeCardOffices
              card={this.props.cards.cardOffices}
              ref={this.state.refsCardsMX[0]}
              properties={["zone", "org", "sales_orgs"]}
              service={this.props.cards.cardOffices.service}
              setRules={this.storageRules}
            />
            */}
          </Grid>
          
          <Grid item xs={4} md={4}>
            <SimpleCard
              card={this.props.cards.cardZone}
              ref={this.state.refsCardsMX[1]}
              property="org"
              service={this.props.cards.cardZone.service}
              setRules={this.storageRules}
            />
          </Grid>
          <Grid item xs={4} md={4}>
            <SimpleCard
              card={this.props.cards.cardDistribution}
              ref={this.state.refsCardsMX[2]}
              property="sales_orgs"
              service={this.props.cards.cardDistribution.service}
              setRules={this.storageRules}
            />
          </Grid>
          
          <Grid item xs={12}>
            <div className="exclutions__category exclutions__category--label"></div>
          </Grid>
          <Grid item xs={4} md={4}>
            <TreeCardSegments
              card={this.props.cards.cardBusinessType}
              ref={this.state.refsCardsMX[3]}
              property={"segment_concesionarios"}
              service={this.props.cards.cardBusinessType.service}
              setRules={this.storageRules}
            />
          </Grid>
          <Grid item xs={4} md={4}>
            <SimpleCard
                card={this.props.cards.cardClientsExceptions}
                ref={this.state.refsCardsMX[4]}
                property="clients_exception"
                count={this.props.cards.cardClientsExceptions.rules || []}
                clients={true}
                setRules={this.storageRules}
                grey={true}
            />
          </Grid>
          <Grid item xs={4} md={4}>
            <SimpleCard
                card={this.props.cards.cardClientsExclusions}
                ref={this.state.refsCardsMX[5]}
                property="clients"
                count={this.props.cards.cardClientsExclusions?.rules || []}
                clients={true}
                setRules={this.storageRules}
                grey={true}
            />
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={12}  container
                direction="row"
                justifyContent="space-between"
                alignItems="center">
            <div className="exclutions__category exclutions__category--label">
              {this.state.titleSales}
            </div>
            {
              this.props.selectedGroupData?
                  <div className="exclutions__category">
                    {this.getRuleStatusMessage(this.props.selectedGroupData.status)}
                  </div>
                  :<></>
            }
          </Grid>

          <Grid item xs={6} md={4}>
            <SimpleCard
              card={this.props.cards.cardZone}
              ref={this.state.refsCards[0]}
              property="sales_orgs"
              service={this.props.cards.cardZone.service}
              setRules={this.storageRules}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <SimpleCard
              card={this.props.cards.cardOffices}
              ref={this.state.refsCards[1]}
              property="offices"
              service={this.props.cards.cardOffices.service}
              setRules={this.storageRules}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <SimpleCard
              card={this.props.cards.cardDistribution}
              ref={this.state.refsCards[2]}
              property="plants"
              service={this.props.cards.cardDistribution.service}
              setRules={this.storageRules}
            />
          </Grid>

          <Grid item xs={12}>
            <div className="exclutions__category exclutions__category--label">
              {this.state.titleClientsType}
            </div>
          </Grid>

          <Grid item xs={6} md={4}>
            <SimpleCard
              card={this.props.cards.cardChannel}
              ref={this.state.refsCards[3]}
              property="channels"
              service={this.props.cards.cardChannel.service}
              setRules={this.storageRules}
              yellow={true}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <SimpleCard
              card={this.props.cards.cardSubChannel}
              ref={this.state.refsCards[4]}
              property="subchannels"
              service={this.props.cards.cardSubChannel.service}
              setRules={this.storageRules}
              yellow={true}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <SimpleCard
              card={this.props.cards.cardBusinessType}
              ref={this.state.refsCards[5]}
              property="business_types"
              service={this.props.cards.cardBusinessType.service}
              setRules={this.storageRules}
              yellow={true}
            />
          </Grid>

          <Grid container item xs={12} spacing={2}>
            <Grid item xs={8}>
              <div className="exclutions__category exclutions__category--label">
                {this.state.titleGeoZone}
              </div>
            </Grid>
          </Grid>
          <Grid item xs={6} md={6}>
            <SimpleCard
              card={this.props.cards.cardState}
              ref={this.state.refsCards[6]}
              property="regions"
              service={this.props.cards.cardState.service}
              setRules={this.storageRules}
              grey={true}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <SimpleCard
              card={this.props.cards.cardCity}
              ref={this.state.refsCards[7]}
              property="municipalities"
              service={this.props.cards.cardCity.service}
              setRules={this.storageRules}
              grey={true}
            />
          </Grid>
          <Grid container item xs={12} spacing={2}>
            <Grid item xs={4}>
              <div className="exclutions__category exclutions__category--label">
                {this.state.titleClients}
              </div>
            </Grid>
          </Grid>
          <Grid item xs={6} md={6}>
            <SimpleCard
              card={this.props.cards.cardClientsExceptions}
              ref={this.state.refsCards[8]}
              property="clients_exception"
              count={this.props.cards.cardClientsExceptions.countClients}
              clients={true}
              setRules={this.storageRules}
              grey={true}
            />
          </Grid>
          <Grid item xs={6} md={6}>
            <SimpleCard
              card={this.props.cards.cardClientsExclusions}
              ref={this.state.refsCards[9]}
              property="clients"
              count={this.props.cards.cardClientsExclusions.countClients}
              clients={true}
              setRules={this.storageRules}
              grey={true}
            />
          </Grid>
        </>
      );

    return (
      <div className="exclutions">
        <div className="exclutions__grid-container">
          <Grid container item xs={12} spacing={2} justifyContent="center">
            {defaultCards}
          </Grid>
        </div>

        <div id="exclutions-actions-container" className="exclutions__actions">
          <div className="exclutions__card__overlay"></div>
          <button
            id="btn-exclutions-remove-validity"
            className="exclutions__button"
            disabled={this.props.selectedDate === null}
            onClick={this.handleButtonRemoveValidity}
          >
            Sin Vigencia
          </button>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              autoOk
              variant="inline"
              inputVariant="outlined"
              emptyLabel="Fecha Inicio"
              disablePast
              disableToolbar
              format="dd/MM/yyyy"
              minDateMessage="La vigencia está vencida, por favor elige otra"
              value={this.props.selectedDateStart}
              onChange={this.handleDateChange("start")}
            />
            <DatePicker
              autoOk
              disabled={this.props.userRoll === "Lector"}
              variant="inline"
              inputVariant="outlined"
              emptyLabel="Fecha Termino"
              disableToolbar
              disablePast
              format="dd/MM/yyyy"
              minDateMessage="La vigencia está vencida, por favor elige otra"
              value={this.props.selectedDateEnd}
              onChange={this.handleDateChange("end")}
            />
          </MuiPickersUtilsProvider>
          <div
            style={{
              float: "right",
              alignItems: "center",
              display: "flex",
            }}
          >
            <Dropdown
              onSelect={this.handleDialogCombo}
              className="loader__dropdown blacke-white"
            >
              <Dropdown.Toggle
                id="dropdown-basic"
                style={{
                  borderRadius: "4px",
                  textAlign: "center",
                  border: "1px solid #000000",
                  padding: "13px",
                  marginRight: "10px",
                  backgroundColor: "#ffffff",
                }}
              >
                {this.state.labelDropdown}
              </Dropdown.Toggle>

              <Dropdown.Menu className="loader__dropdown-menu">
                {this.state.dropdownOptions.map((element) => (
                  <Dropdown.Item eventKey={element}>{element}</Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            <Dialog
              onClose={this.handleDialogClose}
              open={this.state.dialogOpen}
            >
              <div className={`loader__select-file` + viewFileSelection}>
                <StyledDropzone onGetFile={this.handleGetFile} />
              </div>
              <div
                className={`loader__loading-file` + viewLoadingSelection}
                style={
                  this.state.responseCompletedSKU
                    ? {
                        top: "0",
                      }
                    : {}
                }
              >
                <div className={classIconLoading}></div>
                <div className="loader__loading--label">
                  {this.state.responseFileErrorMessage ? (
                      <div>{this.state.responseFileErrorMessage}</div>
                  ) : (
                    <h6>{labelFileLoading}</h6>
                  )}
                </div>
                <LinearProgress
                  variant="determinate"
                  value={this.state.fileProgress}
                />
                <button
                  className={classButtonSuccess}
                  onClick={this.handleLoadingFileCloseButton}
                >
                  {labelButton}
                </button>
              </div>
            </Dialog>

            <DialogLoaderHoneyLoad
              opened={this.state.validating}
              message={
                this.state.totalUploadClients !== 0
                  ? `Validando clientes ${this.state.aculatorUploadClients} de ${this.state.totalUploadClients}`
                  : "Analizando archivo"
              }
              handleClose={(e) => {}}
            />
            <button
              className="exclutions__button black"
              disabled={
                this.props.buttonUpdateDisabled ||
                this.props.userRoll === "Lector"
              }
              onClick={this.handleButtonUploadRulesSKU}
            >
              {this.props.index === 0
                ? this.state.buttonUpdateLabel
                : "Actualizar registro"}
            </button>
          </div>
        </div>

        {this.state.templateDialog}
      </div>
    );
  }
}
